import { gql } from '@apollo/client';

import { BackupMemberFragment } from './backupMembers.fragment';

export * from './backupMemberCreate.mutation.generated';

export const BACKUP_MEMBER_CREATE = gql`
  mutation backupMemberCreate($input: BackupMemberCreateInput!) {
    backupMemberCreate(input: $input) {
      errors
      success
      backupMember {
        ...BackupMemberFragment
      }
    }
  }
  ${BackupMemberFragment}
`;
